var m = require('mithril');
var prop = require('mithril/stream');
var masonry = require('../libs/masonry');
var Draggable = require('../libs/draggable');
var auth = require('../auth/models/session');
var edit = require('../layout/components/edit');
var loaders = require('../layout/components/loaders');
var button = require('../components/button');
var Model = require('../libs/Model');
var modal = require('../layout/components/modal');
var header = require('../layout/components/header');
var modalForm = require('../layout/components/modalForm');
var requestStatusHandler = require('../layout/components/requestStatusHandler');
var RequestStatus = require('../layout/enums/RequestStatus');
var Dashboard = Object.assign(require('../../../../models/dashboards/dashboard'), Model);
var dashboardForm = modalForm(Dashboard);
var addDashboardModal = require('./components/addDashboardModal');
var elementForm = modalForm(require('./models/element'));
var element = require('./components/element');
var templateModal = require('./models/templateModal');
var copyModal = require('./models/copyModal');
var moveDashboardModal = require('./models/moveDashboardModal');
var addLocationModal = require('../locations/addLocationModal');
var alarmsTable = require('../alarms/alarmsTable');
var viewEventTracker = require('../events/viewEventTracker');
var rowActionDropdown = require('../components/rowActionDropdown');
var flash = require('../components/flash');
var sortRecovery = require('./components/sortRecovery');

var oninit = function () {
  var ctrl = this;

  header.vm.activeTab('Dashboards');
  var url = '/api/v1/dashboard/';
  var dashboardKey = m.route.param('key');
  if (dashboardKey) {url += dashboardKey + '/'}
    //Uncomment to activate Homepage for non super users
    //else if(!auth.user().isSuperuser){m.route.set('/home')}; 
  
  
  ctrl.dashboard = prop();
  ctrl.requestStatus = prop(RequestStatus.PENDING);
  ctrl.requestStatusCode = prop();
  ctrl.sortErrors = prop([]);

  ctrl.init = function () {
    viewEventTracker.recordCurrentViewEvent();
    ctrl.dashboard();
    ctrl.requestStatus(RequestStatus.PENDING);
    ctrl.requestStatusCode();
    return loaders.requestWithLoader({
      loader: 'main',
      url: url,
      method: 'GET',
      background: true,
      extract: function(xhr) {
        var response = {
          status: xhr.status,
          body: xhr.responseText ? JSON.parse(xhr.responseText) : null
        };
        if (xhr.status < 200 || xhr.status >= 300) {
          throw {response: response};
        }
        return response.body;
      }
    })
    .then(function (data) {
      if (data.ancestors) {
        document.title = 'nimrod | ' + data.name;        
      } else {
        document.title = 'nimrod | ' + homePageLabel();
      }
      ctrl.dashboard(data);
      ctrl.requestStatus(RequestStatus.SUCCESS);
      m.redraw();
    })
    .catch(function (error) {
      console.error('Error fetching dashboard data:', error);
      ctrl.requestStatusCode(error && (error.status || error.code || (error.response && error.response.status)));
      ctrl.requestStatus(RequestStatus.ERROR);
      m.redraw();
    });
  };

  // modal.on('closed', ctrl.init);

  ctrl.sortChildren = (elements) => {
    var rids = elements.map(n => n.attributes.rid.value);
    return sortRecovery.persistSortOrder({
      context: 'dashboard items',
      message: 'Unable to reorder dashboard items. The latest saved order was reloaded.',
      request: function () {
        return loaders.requestWithLoader({
          loader: 'background',
          method: 'PUT',
          url: '/api/v1/dashboard/' + ctrl.dashboard()['@rid'].slice(1) + '/childorder',
          body: {rids: rids}
        });
      },
      reload: ctrl.init,
      onSuccess: function () {
        ctrl.sortErrors([]);
        m.redraw();
      },
      onError: function (message) {
        ctrl.sortErrors([message]);
        m.redraw();
      }
    });
  };

  ctrl.init();
};

var onremove = function (vnode) {
  modal.off('closed');
};

function sortOnIndex (a,b) {
   return (a.index || 0) - (b.index || 0);
}

function sortOnName (a, b) {
 var nameA = a.in.name.toLowerCase(); 
 var nameB = b.in.name.toLowerCase();
 if (nameA < nameB) //sort string ascending
  return -1;
 if (nameA > nameB)
  return 1;
 return 0; //default return value (no sorting)
};

var LOCATION_PARENT_CLASSES = ['Site', 'Building', 'Level', 'Room'];

function homePageLabel() {
  if (typeof nrSiteName !== 'undefined' && nrSiteName) {
    return nrSiteName;
  }
  return 'Home';
}

function getImmediateParentAncestor(dashboardRecord) {
  if (!dashboardRecord || !Array.isArray(dashboardRecord.ancestors)) {
    return null;
  }

  var ancestors = dashboardRecord.ancestors;
  var currentRid = dashboardRecord['@rid'] ? dashboardRecord['@rid'].toString() : null;
  if (!currentRid) {
    return null;
  }

  for (var idx = ancestors.length - 1; idx >= 0; idx -= 1) {
    var ancestor = ancestors[idx];
    if (ancestor && ancestor['@rid'] && ancestor['@rid'].toString() === currentRid) {
      return idx > 0 ? ancestors[idx - 1] : null;
    }
  }

  return null;
}

function isDashboardParentLocation(dashboardRecord) {
  var parent = getImmediateParentAncestor(dashboardRecord);
  return !!(parent && LOCATION_PARENT_CLASSES.indexOf(parent['@class']) !== -1);
}

function currentUserIsSuperuser() {
  var user = auth.user && auth.user();
  return !!(user && (parseInt(user.isSuperuser) || user.isSuperuser === true || parseInt(user.is_superuser)));
}

function canLinkToAncestor(ancestor) {
  if (!ancestor) return false;
  if (ancestor.name === 'root') return true;
  if (ancestor['@class'] !== 'Dashboard') return true;
  if (currentUserIsSuperuser()) return true;
  return !!(ancestor.permission && Number(ancestor.permission.read));
}

function ancestorHref(ancestor) {
  if (!ancestor) return null;
  if (ancestor.name === 'root') return '/';
  if (ancestor['@rid'] && ancestor['@class'] === 'Dashboard') {
    return '/dashboard/' + ancestor['@rid'].slice(1);
  }
  if (ancestor['@rid'] && LOCATION_PARENT_CLASSES.indexOf(ancestor['@class']) !== -1) {
    return '/location/' + ancestor['@rid'].slice(1);
  }
  if (ancestor['@id']) {
    return '/' + ancestor['@id'].split('/').slice(3).join('/');
  }
  return null;
}

function ancestorBreadcrumbLabel(ancestor) {
  return ancestor && ancestor.name === 'root' ? 'Home' : ancestor.name;
}

function ancestorBreadcrumbContent(ancestor) {
  var label = ancestorBreadcrumbLabel(ancestor);
  var href = ancestorHref(ancestor);
  return href && canLinkToAncestor(ancestor)
    ? m(m.route.Link, { href: href }, label)
    : m('span', label);
}

var view = function () {
  var ctrl = this;
  if (ctrl.requestStatus() !== RequestStatus.SUCCESS || !ctrl.dashboard()) {
    return m(requestStatusHandler, {
      requestStatus: ctrl.requestStatus,
      requestStatusCode: ctrl.requestStatusCode,
      onRetry: ctrl.init
    });
  }
  return m('div', [
    m(flash, { items: ctrl.sortErrors(), bg: 'bg-red' }),
    function heading () {
      if (ctrl.dashboard().ancestors) {
        var displayHeader = 'none'
        return m('div.flex.justify-between.mh3.mb3.pb2.bb.bw1.b--mid-gray.near-white.display', [
          m('div', [
            auth.user().homeDashboard && auth.user().isSuperuser != 1 ? 
              ctrl.dashboard().ancestors.map( function (ancestor, idx) {
                if (ancestor['@rid'].toString() === ctrl.dashboard()['@rid'].toString()) {
                  if(ancestor['@rid'].slice(1) === auth.user().homeDashboard){ displayHeader = 'inline'}                 
                  return m('div.mr2.dib-ns', {style: {display: displayHeader}}, ctrl.dashboard().name);
                } else {
                  if(ancestor['@rid'].slice(1) === auth.user().homeDashboard){ displayHeader = 'inline'}                 
                    return m('div.mr2.dib-ns', {style: {display: displayHeader}},[
                      ancestorBreadcrumbContent(ancestor),
                    ' / '
                  ]);
                }
              })
            :
              ctrl.dashboard().ancestors.map( function (ancestor, idx) {
                if (ancestor.name === 'root') {
                  return m('div.mr2.dib-ns', [
                    ancestorBreadcrumbContent(ancestor),
                    ' / '
                  ]);
                } else if (ancestor['@rid'].toString() === ctrl.dashboard()['@rid'].toString()) {
                  return m('div.mr2.dib-ns', ctrl.dashboard().name);
                } else {
                  return m('div.mr2.dib-ns', [
                    ancestorBreadcrumbContent(ancestor),
                    ' / ',
                  ]);

                }
              })
          ]),
          (function () {
            if (edit.vm.editing()) {
              return m(rowActionDropdown, {
                items: [
                  {
                    label: 'Edit Dashboard',
                    icon: 'ion-ios-compose',
                    onclick: dashboardForm.editDialogue.bind(dashboardForm, ctrl.dashboard(), {submitCallback: ctrl.init})
                  },
                  {
                    label: 'Load elements from template',
                    icon: 'ion-ios-upload',
                    onclick: templateModal.editDialogue.bind(templateModal, ctrl.dashboard(), {submitCallback: ctrl.init})
                  },
                  {
                    label: 'Download template from elements',
                    icon: 'ion-ios-download',
                    onclick: () => generateTemplate(ctrl)
                  }
                ]
              })
            }
          })()
        ]);
      } else {
        const dashboardRid = ctrl.dashboard() && ctrl.dashboard()['@rid'];
        return m('div.flex.justify-between.mh3.mb3.pb1.bb.bw1.b--mid-gray.near-white', [
          m('span.f-subheadline.display', homePageLabel()),
          edit.vm.editing() ? 
            m(rowActionDropdown, {
              items: dashboardRid ? [
                {
                  label: 'Edit permissions',
                  icon: 'ion-ios-people',
                  onclick: function () {
                    m.route.set('/dashboard/' + dashboardRid.toString().slice(1) + '/permissions');
                  }
                }
              ] : []
            })
          :
            ''
        ])
      }
    }(),
    function buildOrBrowse() {
      if (edit.vm.editing()) {
        return buildBody(ctrl);
      }
      else {
        return BrowseBody(ctrl);
      }
    }()
  ]);
};

function BrowseBody (ctrl)  {
  if (typeof ctrl.dashboard().out_Contains === 'undefined' || ctrl.dashboard().out_Contains === null) {
    return m('div');
  }
  var elements = ctrl.dashboard().out_Contains.filter(function (record) {
    return record.in['@class'] === 'Element';
  })
  .sort(sortOnIndex)
  .map(function (child, idx) {
    child.permission = ctrl.dashboard().permission
    let parentLocation;
    if (ctrl.dashboard().ancestors && ctrl.dashboard().ancestors[ctrl.dashboard().ancestors.length - 2] !== 'Dashboard') {
      parentLocation = ctrl.dashboard().ancestors[ctrl.dashboard().ancestors.length - 2];
    }
  
    return m(element, { child, parentRid: ctrl.dashboard()['@rid'], location: prop(parentLocation)});
  });

  elements.unshift(m('div.grid-item.w-100.w-50-ns.w-25-l')); //Fake div for get Masonry work
  elements.unshift(m('div.grid-sizer'));

  var dashboardChildren = ctrl.dashboard().out_Contains
  .filter(function (record) {
    return record.in['@class'] === 'Dashboard';
  })
  .sort(sortOnName);

  var navs = dashboardChildren
  .map(function (child) {
    return dashboardLinkTemplate(child.in);
  });

  var locationChildren = ctrl.dashboard().out_Contains
  .filter(function (record) {
    return record.in['@class'] === 'Site';
  })
  .sort(sortOnName);

  var locations = locationChildren
  .map(function (child) {
    return locationLinkTemplate(child.in);
  });

  var accessibleDashboardRecords = ctrl.dashboard().accessibleDashboards || [];
  var accessibleDashboardLinks = accessibleDashboardRecords
  .map(function (record) {
    return accessibleDashboardLinkTemplate(record);
  });

  var isHomeDashboard = !ctrl.dashboard().ancestors;
  var homeDashboardRecords = dashboardChildren.map(function (child) {
    return { dashboard: child.in, path: [] };
  }).concat(accessibleDashboardRecords);

  return m('div', [ 
    isHomeDashboard ?
      renderHomeLinks(
        locationChildren.map(function (child) { return child.in; }),
        homeDashboardRecords
      )
    :
      [
        m('div.cf.mh2.mb3', navs, locations),
        accessibleDashboardLinks.length ?
          m('div.cf.mh3.mb3', [
            m('div.f4.moon-gray.mb2', 'Accessible Dashboards'),
            accessibleDashboardLinks
          ])
        : ''
      ],
    m('div.cf', { onupdate: (ctrl.dashboard().masonry == 0 ? undefined : masonry)}, elements),
    parseInt(auth.user().isSuperuser) || auth.user().isSuperuser == true ? 
      m('div.cf.mh3', [
        m(alarmsTable, {
          equipmentAllRids: [],
          dashboardsAllRids: [ctrl.dashboard()['@rid']],
          selectedView: prop('Dashboard'),
          location: ctrl.dashboard,
        })
      ])
    :
      ''
  ])


  function renderHomeLinks (locationRecords, dashboardRecords) {
    var links = [];
    locationRecords.forEach(function (location) {
      links.push({
        type: 'location',
        label: location.name,
        href: '/location/' + location['@rid'].slice(1),
        iconClass: 'ion-map',
        detail: ''
      });
    });
    dashboardRecords.forEach(function (record) {
      var dash = record.dashboard || {};
      links.push({
        type: 'dashboard',
        label: dash.name,
        href: '/dashboard/' + dash['@rid'].slice(1),
        iconSrc: '/images/dashboard_icon.svg',
        detail: ''
      });
    });

    links.sort(function (a, b) {
      return String(a.label || '').localeCompare(String(b.label || ''), undefined, { sensitivity: 'base' });
    });

    return m('div.cf.mh2.mb3', links.map(function (record) {
      return m('div.fl.w-100.w-50-ns.w-third-l.ph2', [
        linkButtonTemplate(record)
      ]);
    }));
  }

  function linkButtonTemplate (record) {
    var icon = record.iconSrc ?
      m('img.mr3.flex-shrink-0', { src: record.iconSrc, width: 22, height: 24 }) :
      m('i.icon.f1.blue.mr3', { class: record.iconClass });
    return m(m.route.Link, {href: record.href}, [
      m('div.flex.justify-between.items-center.ba.b--mid-gray.bw1.pa3.mb3.f3', { style: { minHeight: '4rem' } }, [
        m('div.flex.items-center.truncate', [
          icon,
          m('div.truncate', [
            m('p.pa0.ma0.truncate.f3.fw4', record.label),
            record.detail ? m('p.pa0.ma0.mt1.truncate', { class: 'moon-gray f7' }, record.detail) : ''
          ])
        ]),
        m('i.icon.ion-ios-arrow-right.ml3')
      ])
    ]);
  }

  function dashboardLinkTemplate (dash) {
    return m('div.fl.w-100.w-50-ns.w-third-l.ph2', [
      linkButtonTemplate({
        label: dash.name,
        href: '/dashboard/' + dash['@rid'].slice(1),
        iconSrc: '/images/dashboard_icon.svg',
        detail: ''
      })
    ])
  }

  function locationLinkTemplate (location) {
    return m('div.fl.w-100.w-50-ns.w-third-l.ph2', [
      linkButtonTemplate({
        label: location.name,
        href: '/location/' + location['@rid'].slice(1),
        iconClass: 'ion-map',
        detail: ''
      })
    ])
  }

  function accessibleDashboardLinkTemplate (record) {
    var dash = record.dashboard || {};

    return m('div.fl.w-100.w-50-ns.w-third-l.ph2', [
      linkButtonTemplate({
        label: dash.name,
        href: '/dashboard/' + dash['@rid'].slice(1),
        iconSrc: '/images/dashboard_icon.svg',
        detail: ''
      })
    ])
  }
} 

function buildBody (ctrl) {
  var allowSmartElements = isDashboardParentLocation(ctrl.dashboard());
  var newElementRecord = {parent: ctrl.dashboard()['@rid']};
  if (!allowSmartElements) {
    newElementRecord.smartElementCreationAllowed = false;
  }

  var forms = m('div.fl.w-100.flex.flex-wrap', [
    m('div.fl.w-100.w-50-ns.w-50-l.ph3.f6.mv1', {
      onclick: elementForm.editDialogue.bind(elementForm, newElementRecord, {submitCallback: ctrl.init})
    }, [
      m('div.flex.items-center.justify-center.flex-column.ba.b--dashed.pa2.blue.bw1.h5', [
        m('i.f-headline', {class: 'icon ion-plus icon-right'}),
        m('span', 'New Element'),
      ])
    ])
  ])

  if (!ctrl.dashboard().out_Contains && !ctrl.dashboard().useHasDashboardEdge) {
    return m('div.grid-item', [
      m('div.grid-item.fl.w-100.w-50-ns.w-25-l.ph3.pv2.relative', {
        onclick: addDashboardModal.editDialogue.bind(addDashboardModal, undefined, ctrl.dashboard(), false, {submitCallback: ctrl.init}),
      }, [
        m('div.flex.justify-between.ba.b--dashed.pa2.blue.bw1.w-100', [
          m('span', 'New Dashboard'),
          m('i', {class: 'icon ion-plus icon-right'}) 
        ])
      ]),
      forms
    ]);
  }

  let parentLocation;
  if (ctrl.dashboard().ancestors && ctrl.dashboard().ancestors[ctrl.dashboard().ancestors.length - 2] !== 'Dashboard') {
    parentLocation = ctrl.dashboard().ancestors[ctrl.dashboard().ancestors.length - 2];
  }

  var elements = (ctrl.dashboard().out_Contains || [])
  .filter(function (record) {
    return record.in['@class'] === 'Element';
  })
  .sort(sortOnIndex)
  .map(function (child) {
    if (child.in['@class'] === 'Element') {
      return m(element, {child:child, key: child['@rid'], dashboardCallback: ctrl.init, parentRid: ctrl.dashboard()['@rid'], location: prop(parentLocation)});
    }
  });
  
  elements.unshift(m('div.grid-sizer',{ key: 0 }));

  function childDashboardTemplate (containsEdge) {
    var dashboard = containsEdge.in;
    var url = Dashboard.getUrl(dashboard);
    dashboard.parent = ctrl.dashboard()['@rid'];
    return m('div.grid-item.fl.w-100.w-50-ns.w-25-l.ph3.pv2.relative', [
      m('div.items-center.ba.bw1.pa2.flex.justify-between', [
        m(m.route.Link, {href: '/dashboard/' + dashboard['@rid'].slice(1), class: 'truncate'}, [
          dashboard.name,
        ]),
        m(rowActionDropdown, {
          items: [
            {
              label: 'Edit dashboard',
              icon: 'ion-ios-compose',
              onclick: dashboardForm.editDialogue.bind(dashboardForm, dashboard, {delete:'true', dashboardCallback: ctrl.init, submitCallback: ctrl.init})
            },
            {
              label: 'Move dashboard to dashboard',
              icon: 'ion-android-exit',
              onclick: moveDashboardModal.editDialogue.bind(moveDashboardModal, containsEdge, {submitCallback: ctrl.init, showLocationSelector: false})
            },
            {
              label: 'Edit permissions',
              icon: 'ion-ios-people',
              onclick: function () {
                m.route.set('/dashboard/' + dashboard['@rid'].toString().slice(1) + '/permissions');
              }
            },
            {
              label: 'Copy dashboard',
              icon: 'ion-ios-copy',
              onclick: copyModal.editDialogue.bind(copyModal, dashboard, {submitCallback: ctrl.init})
            }
          ]
        })
      ]),
    ])
  }

  function childLocationTemplate (containsEdge) {
    var location = containsEdge.in;
    return m('div.grid-item.fl.w-100.w-50-ns.w-25-l.ph3.pv2.relative', [
      m('div.items-center.ba.bw1.pa2.flex.justify-between', [
        m(m.route.Link, {href: '/location/' + location['@rid'].slice(1), class: 'truncate'}, [
          location.name,
        ]),
        m('div.nowrap',[
          m('i.icon.ion-android-compass.ph2.blue'),
          m(rowActionDropdown, {
            items: [
              {
                label: 'Edit Site',
                icon: 'ion-ios-compose',
                onclick: addLocationModal.editDialogue.bind(addLocationModal, location, {delete:'true', submitCallback: ctrl.init, dashboardCallback: ctrl.init})
              },
              {
                label: 'Edit permissions',
                icon: 'ion-ios-people',
                onclick: function () {
                  m.route.set('/location/' + location['@rid'].toString().slice(1) + '/permissions');
                }
              }
            ]
          })
        ]),
      ]),
    ])
  }

  var dashboards = (ctrl.dashboard().out_Contains || [])
    .filter(function (record) {
      return record.in['@class'] === 'Dashboard';
    })
    .sort(sortOnName)
    .map(function (child) {
      return childDashboardTemplate(child);
    })


  var locations = (ctrl.dashboard().out_Contains || [])
    .filter(function (record) {
      return record.in['@class'] === 'Site';
    })
    .sort(sortOnName)
    .map(function (child) {
      return childLocationTemplate(child);
    })


  return m('div', [
    m('div.cf', 
      dashboards,
      // locations,
      !ctrl.dashboard().useHasDashboardEdge ? 
      m('div.grid-item.fl.w-100.w-50-ns.w-25-l.ph3.pv2.relative', {
        onclick: addDashboardModal.editDialogue.bind(addDashboardModal, undefined, ctrl.dashboard(), false, {submitCallback: ctrl.init}),
      }, [
        m('div.flex.justify-between.ba.b--dashed.pa2.blue.bw1.w-100', [
          m('span', 'New Dashboard'),
          m('i', {class: 'icon ion-plus icon-right'}) 
        ])
      ])  
      :
        ''
    ),
    m(Draggable, {onsort: ctrl.sortChildren, draggable: '.grid-item', handleClass:'.grid-item-drag-handle'}, elements),
    m('div', {style:{'position':'static'},class: 'cf'}, forms)
  ]);
}


function generateTemplate(ctrl) {
  return loaders.requestWithLoader({
    loader: 'main',
    url: '/api/v1/dashboard/'+ctrl.dashboard()['@rid'].slice(1)+'/template',
    method: 'GET'
  })
  .then( result => {
    download(JSON.stringify(result), 'json.txt', 'text/plain');
  })
}

function download(content, fileName, contentType) {
  var a = document.createElement("a");
  var file = new Blob([content], {type: contentType});
  a.href = URL.createObjectURL(file);
  a.download = fileName;
  a.click();
}

module.exports = {oninit: oninit, onremove: onremove, view: view}
